export const getDeclarationsForPolicy = (declaration, values) => {
	let declarations = [];
	declaration?.value?.forEach((dec, i) => {
		if (dec.acceptType === 1) {
			declarations = [
				...declarations,
				{
					declarationAcceptType: dec.acceptType,
					declarationId: dec.instanceId,
					name: dec.name,
					value: values[`checkboxDec${i}`] ?? ''
				}
			];
		}
		if (dec.acceptType === 2) {
			declarations = [
				...declarations,
				{
					declarationAcceptType: dec.acceptType,
					declarationId: dec.instanceId,
					name: dec.name,
					value: values[`otpDec${i}`]?.split('~')[0] ?? ''
				}
			];
		}
		if (dec.acceptType === 3) {
			declarations = [
				...declarations,
				{
					declarationAcceptType: dec.acceptType,
					declarationId: dec.instanceId,
					name: dec.name,
					value: values[`signDec${i}`] ?? ''
				}
			];
		}
	});
	return declarations;
};

// Returns true when any mandatory declaration field is unfilled or explicitly false.
// Accepts declaration store slice and current formValues so it stays a pure function.
export const checkMandatoryDeclarations = (declaration, formValues) => {
	let val = [];
	declaration?.value?.forEach((dec, i) => {
		if (dec.acceptType === 1 && dec.isMandatory) {
			val = [...val, formValues[`checkboxDec${i}`]];
		}
		if (dec.acceptType === 2 && dec.isMandatory) {
			val = [...val, formValues[`otpDec${i}`]];
		}
		if (dec.acceptType === 3 && dec.isMandatory) {
			val = [...val, formValues[`signDec${i}`]];
		}
	});
	return val.includes(undefined) || val.includes(false);
};
